webpackJsonp([42],{

/***/ 387:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(52)(
  /* script */
  __webpack_require__(775),
  /* template */
  __webpack_require__(850),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 775:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_app_cfg__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_handy__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_handy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__utils_handy__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      // common
      lAction: '',
      sbar: false,
      sbarCol: 'error',
      sbarMsg: '',
      handy: __WEBPACK_IMPORTED_MODULE_1__utils_handy___default.a,
      config: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a,
      rules: __WEBPACK_IMPORTED_MODULE_1__utils_handy___default.a.rules,
      beingSaved: false,
      dtDlg: false,

      // screen specific
      lJournal: '',
      accHeads: [],
      journalList: [],
      journalHead: [{ text: 'Description', value: 'trans_desc' }, { text: 'Date', value: 'trans_dt' }, { text: 'Account', value: 'gl_acc_name' }, { text: 'Debit', value: 'debit_amount' }, { text: 'Credit', value: 'credit_amount' }, { text: 'Action', value: '', width: '100px' }]
    };
  },
  // data
  computed: {
    today: function today() {
      return __WEBPACK_IMPORTED_MODULE_1__utils_handy___default.a.formatDBDate(Date());
    }
  },
  created: function created() {
    this.loadRecJournal();
    this.loadAccHeads();
    this.lAction = 'view';
  },

  methods: {
    // common methods
    msg: function msg(m) {
      var isError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.sbarCol = isError ? 'error' : 'success';
      this.sbar = true;
      this.sbarMsg = m;
    },

    // screen specific methods
    loadRecJournal: function loadRecJournal() {
      var _this = this;

      // existing accounts
      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.COMM_ID
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/getRecentJournals/', qry).then(function (response) {
        _this.journalList = response.data;
      }).catch(function (err) {
        _this.msg(err.response.data, true);
        _this.journalList = [];
      });
    },
    loadAccHeads: function loadAccHeads() {
      var _this2 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.COMM_ID
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/getAccountHeadsLiteByCommId/', qry).then(function (response) {
        _this2.accHeads = response.data;
      }).catch(function (err) {
        _this2.msg(err.response.data, true);
        _this2.accHeads = [];
      });
    },
    prepareCreate: function prepareCreate() {
      this.lJournal = this.getEmptyJournal();
      this.lAction = 'create';
    },
    getEmptyJournal: function getEmptyJournal() {
      var emptyJournal = {
        comm_id: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.COMM_ID,
        trans_dt: '',
        trans_desc: '',
        trans_amount: '',
        debit_gl_pair: '',
        credit_gl_pair: ''
      };
      return emptyJournal;
    },
    saveChanges: function saveChanges() {
      var _this3 = this;

      if (!this.$refs.lForm.validate()) {
        return;
      }
      if (!this.lJournal.debit_gl_pair || !this.lJournal.debit_gl_pair.gl_acc_id) {
        this.msg('Please choose debit account', true);
        return;
      }
      if (!this.lJournal.credit_gl_pair || !this.lJournal.credit_gl_pair.gl_acc_id) {
        this.msg('Please choose credit account', true);
        return;
      }
      this.beingSaved = true;
      // pre-req
      this.lJournal.debit_gl_acc_id = this.lJournal.debit_gl_pair.gl_acc_id;
      this.lJournal.debit_gl_acc_type = this.lJournal.debit_gl_pair.gl_acc_type;
      this.lJournal.credit_gl_acc_id = this.lJournal.credit_gl_pair.gl_acc_id;
      this.lJournal.credit_gl_acc_type = this.lJournal.credit_gl_pair.gl_acc_type;

      this.axios.post(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/journal/create', this.lJournal).then(function (response) {
        // update the frontend
        _this3.loadRecJournal();
        _this3.lAction = 'view';
        _this3.beingSaved = false;
      }).catch(function (err) {
        _this3.msg(err.response.data, true);
        _this3.beingSaved = false;
      });
    },
    cancelChanges: function cancelChanges() {
      this.lAction = 'view';
    },
    deleteJournalTrans: function deleteJournalTrans(curJournal) {
      var _this4 = this;

      // confirm
      if (confirm('Sure, you want to delete the journal transaction of account "' + curJournal.gl_acc_name + '"?\n' + 'IMPORTANT: Ensure deleting the pair of this transaction as well')) {
        // delete
        this.axios.post(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/journal/delete', curJournal).then(function (response) {
          // update the frontend
          _this4.loadRecJournal();
          _this4.lAction = 'view';
          _this4.beingSaved = false;
        }).catch(function (err) {
          _this4.msg(err.response.data, true);
          _this4.beingSaved = false;
        });
      }
    }
  } // methods
  // export

});

/***/ }),

/***/ 850:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-1",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.lAction === 'view') ? _c('v-container', {
    staticClass: "pa-1"
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mx-auto": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "pa-2 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("Recent Journal Entries")])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-data-table', {
    staticClass: "elevation-0",
    attrs: {
      "headers": _vm.journalHead,
      "items": _vm.journalList,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(props.item.trans_desc))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.handy.formatDate(props.item.trans_dt)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.gl_acc_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.debit_amount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.credit_amount))]), _vm._v(" "), _c('td', [_c('v-btn', {
          attrs: {
            "icon": "",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteJournalTrans(props.item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("delete")])], 1)], 1)])]
      }
    }], null, false, 2821891296)
  })], 1)], 1), _vm._v(" "), _c('v-btn', {
    style: ('position:fixed; ' + (_vm.$vuetify.breakpoint.smAndDown ? 'bottom:15px; right:15px;' : 'bottom:15px; right:15px;')),
    attrs: {
      "dark": "",
      "fab": "",
      "fixed": "",
      "color": "accent"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.prepareCreate()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'create') ? _c('v-container', {
    staticClass: "pa-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-form', {
    ref: "lForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveChanges(_vm.lAction)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm9": "",
      "mx-auto": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pt-1 pb-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Description",
      "rules": [_vm.rules.required],
      "hint": "The narration of this journal entry",
      "persistent-hint": "",
      "maxlength": "150"
    },
    model: {
      value: (_vm.lJournal.trans_desc),
      callback: function($$v) {
        _vm.$set(_vm.lJournal, "trans_desc", $$v)
      },
      expression: "lJournal.trans_desc"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgJournalDt",
    attrs: {
      "persistent": "",
      "lazy": "",
      "full-width": "",
      "width": "290px",
      "return-value": _vm.lJournal.trans_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lJournal, "trans_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lJournal, "trans_dt", $event)
      }
    },
    model: {
      value: (_vm.dtDlg),
      callback: function($$v) {
        _vm.dtDlg = $$v
      },
      expression: "dtDlg"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Date",
      "append-icon": "event",
      "readonly": "",
      "rules": [_vm.rules.required]
    },
    slot: "activator",
    model: {
      value: (_vm.lJournal.trans_dt),
      callback: function($$v) {
        _vm.$set(_vm.lJournal, "trans_dt", $$v)
      },
      expression: "lJournal.trans_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "first-day-of-week": "1",
      "max": _vm.today
    },
    model: {
      value: (_vm.lJournal.trans_dt),
      callback: function($$v) {
        _vm.$set(_vm.lJournal, "trans_dt", $$v)
      },
      expression: "lJournal.trans_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dtDlg = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgJournalDt.save(_vm.lJournal.trans_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Amount",
      "rules": [_vm.rules.required],
      "type": "number"
    },
    model: {
      value: (_vm.lJournal.trans_amount),
      callback: function($$v) {
        _vm.$set(_vm.lJournal, "trans_amount", $$v)
      },
      expression: "lJournal.trans_amount"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-combobox', {
    attrs: {
      "label": "Debit Account",
      "items": _vm.accHeads,
      "item-value": "gl_acc_id",
      "item-text": "gl_acc_name",
      "rules": [_vm.rules.required],
      "clearable": ""
    },
    model: {
      value: (_vm.lJournal.debit_gl_pair),
      callback: function($$v) {
        _vm.$set(_vm.lJournal, "debit_gl_pair", $$v)
      },
      expression: "lJournal.debit_gl_pair"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-combobox', {
    attrs: {
      "label": "Credit Account",
      "items": _vm.accHeads,
      "item-value": "gl_acc_id",
      "item-text": "gl_acc_name",
      "rules": [_vm.rules.required],
      "clearable": ""
    },
    model: {
      value: (_vm.lJournal.credit_gl_pair),
      callback: function($$v) {
        _vm.$set(_vm.lJournal, "credit_gl_pair", $$v)
      },
      expression: "lJournal.credit_gl_pair"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    staticClass: "pa-2",
    attrs: {
      "value": "true",
      "outline": "",
      "color": "info"
    }
  }, [_vm._v("HINT:"), _c('br'), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n                        Income Adj. - Choose "), _c('span', {
    staticClass: "accent--text"
  }, [_vm._v("bank/cash")]), _vm._v(" as debit account and "), _c('span', {
    staticClass: "accent--text"
  }, [_vm._v("unit no.")]), _vm._v(" from whom money is received as credit account\n                      ")]), _vm._v(" "), _c('li', [_vm._v("\n                        Expense Adj. - Choose "), _c('span', {
    staticClass: "accent--text"
  }, [_vm._v("vendor")]), _vm._v(" who receives money as debit account and "), _c('span', {
    staticClass: "accent--text"
  }, [_vm._v("bank/cash")]), _vm._v(" as credit\n                      ")]), _vm._v(" "), _c('li', [_vm._v("\n                        Write-off Balance - Choose "), _c('span', {
    staticClass: "accent--text"
  }, [_vm._v("Bad Debts or Round off")]), _vm._v(" as debit account and "), _c('span', {
    staticClass: "accent--text"
  }, [_vm._v("unit no.")]), _vm._v(" as credit account\n                      ")])])])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.cancelChanges($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "submit",
      "disabled": _vm.beingSaved,
      "color": "accent"
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 2000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/42.a6b99a5e587f4faa6367.js